/* 2026-10-19 JS Site: premium Chanukah pages. Scroll reveal (below the fold only, honors reduced motion) and maker filter chips. */
(function(){
  'use strict';
  var roots=document.querySelectorAll('.jcp');
  if(!roots.length)return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reduce&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -6% 0px',threshold:0.01});
    var vh=window.innerHeight||800;
    roots.forEach(function(r){r.querySelectorAll('[data-rv]').forEach(function(el){
      if(el.getBoundingClientRect().top<vh*1.05)return;
      el.classList.add('rv-pre');io.observe(el);
    });});
  }
  roots.forEach(function(r){
    var box=r.querySelector('[data-jcp-chips]');var grid=r.querySelector('[data-jcp-grid]');
    if(!box||!grid)return;
    var cards=[].slice.call(grid.querySelectorAll('.jcp-card'));
    box.addEventListener('click',function(e){var b=e.target.closest('.jcp-chip');if(!b)return;var f=b.dataset.f;
      box.querySelectorAll('.jcp-chip').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false');});
      cards.forEach(function(c){var show=f==='*'||c.getAttribute('data-v')===f;c.hidden=!show;if(show){c.classList.remove('rv-pre');c.classList.add('is-in');}});
    });
  });
})();
